import { HttpClient } from '@wix/http-client';
import moment from 'moment';
import { useCallback, useContext } from 'react';
import { v4 } from 'uuid';

import { Context } from '../context';
import { LogBI, SessionBIType } from '../types';
import { useStore } from '../zustand/stores';

export const useSessionBI = () => {
  const { sessionBI, setSessionBI, fetchSessionDebounceBI } =
    useContext(Context);
  const { user } = useStore((state) => state.userSlice);

  const getSessionBI = useCallback(
    (_: LogBI) =>
      new Promise<string | null>((resolve) => {
        if (location.hostname === 'localhost') {
          return resolve(v4());
        }

        const { lastSessionDate, selfServiceSessionId } = sessionBI;
        const diffSeconds = moment().diff(lastSessionDate, 'seconds');
        if (!selfServiceSessionId || diffSeconds > 20) {
          fetchSessionDebounceBI(user !== null)
            .then((value) => {
              setSessionBI({
                lastSessionDate: moment(),
                selfServiceSessionId: value,
              });
              resolve(value);
            })
            .catch(() => resolve(null));
        } else {
          resolve(selfServiceSessionId);
        }
      }),
    [sessionBI.lastSessionDate, sessionBI.selfServiceSessionId]
  );

  return { getSessionBI };
};

export const fetchSessionBI = async (
  isLoggedInUser: boolean
): Promise<string | null> => {
  let isConvertFlow = false;
  if (isLoggedInUser) {
    const sessionType = localStorage.getItem('hc_session_bi_type');
    if (sessionType === SessionBIType.VISITOR) {
      localStorage.setItem('hc_session_bi_type', SessionBIType.USER);
      isConvertFlow = true;
    }
  }

  const httpClient = new HttpClient();
  return httpClient
    .put<{ helpWidgetSession: { sessionId: string } }>(
      `https://support.wix.com/_serverless/cc-user-facing-service/bi/session?flow=${
        isConvertFlow ? 'convert' : 'regular'
      }`
    )
    .then((res) => res.data.helpWidgetSession.sessionId)
    .catch(() => null);
};
